
class Filter {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.init()
        this.filter = ''
        this.content = null
    }
    init() {
        this.content = document.querySelector('[data-filter-content]')
        document.querySelectorAll('[data-filter]').forEach((item) => {
            new FilterGroup(item, this)
        })
        window.matchMedia('(max-width: 768px)').addEventListener('change', (evt) => {
            this.update()
        })
        setTimeout(() => {
            this.update()
        }, 100)
    }
    setFilterActive(filter) {
        this.filter = filter
        this.update()
    }
    update() {
        if (!this.content) {
            this.content = document.querySelector('[data-filter-content]')
        }

        if (!this.content) {
            return
        }

        this.content.classList.add('is-loading')

        const url = new URL(window.location.href)
        url.searchParams.set('f', this.filter)
        url.searchParams.set('c', true)
        if ('' === this.filter) {
            url.searchParams.delete('f')
        }

        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                const list = doc.querySelector('[data-filter-content]')
                this.content.innerHTML = list.innerHTML
                this.content.classList.remove('is-loading')

                const event = new CustomEvent('filter:change', {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        filter: this.filter
                    }
                })
                window.dispatchEvent(event)
                url.searchParams.delete('c')
                window.history.pushState({}, '', url)
            })
    }
}

class FilterGroup {
    constructor(element, parent) {
        this.element = element
        this.parent = parent
        this.list = []
        this.init()
    }
    init() {
        this.element.querySelectorAll('[data-filter-item]').forEach((item) => {
            this.list.push(new FilterItem(item, this))
        })
    }
    clear() {
        this.list.forEach((item) => {
            item.element.classList.remove('filter__item--is-active')
        })
        this.element.classList.remove('filter--is-apply2')
    }
    active() {
        this.element.classList.add('filter--is-apply')
    }
    active2() {
        this.element.classList.add('filter--is-apply2')
    }
    desactive() {
        this.element.classList.remove('filter--is-apply')
    }
    setFilterActive(filter) {
        this.parent.setFilterActive(filter)
    }
}
class FilterItem {
    constructor(element, parent) {
        this.element = element
        this.parent = parent
        this.init()
    }
    init() {
        this.element.addEventListener('click', (evt) => {
            evt.preventDefault()
            this.parent.clear()

            if ('all' === this.element.dataset.filterItem) {
                this.parent.setFilterActive('')
                return
            }

            this.parent.setFilterActive(this.element.dataset.filterItem)
            this.parent.active2()
            this.element.classList.add('filter__item--is-active')
        })
        this.element.addEventListener('mouseover', () => {
            this.parent.active()
            this.element.classList.add('filter__item--is-hover')
        })
        this.element.addEventListener('mouseleave', () => {
            this.parent.desactive()
            this.element.classList.remove('filter__item--is-hover')
        })
    }
}

export default Filter